<section class="containerFinancials" [ngClass]="{ 'col-md-12': !isMobile }">
	<div class="search-header">
		<h1>{{ 'PAGES.FINANCIALS.TITLE' | translate }}</h1>
	</div>

	<div
		class="zk-flex buttons-search zk-mb-5"
		*ngIf="showClientSearch && !isProfessionalZen || !isProfessionalZenPartner"
	>
		<div *ngFor="let dashConfig of (isSupersetEnabled ? dashboardsSuperset : dashboards)">
			<button
				zk-button
				zkButtonSize="small"
				class="zk-mr-2"
				[style]="{ width: dashConfig.width + 'px' }"
				[zkButtonColor]="
					dashConfig.dashboard === dashboard
						? zkEButtonColor.PRIMARY
						: zkEButtonColor.SECONDARY
				"
				(click)="changeDashboard(dashConfig.dashboard)"
			>
				{{ dashConfig.label | translate }}
			</button>
		</div>
	</div>

	<!-- List financials -->
	<div style="height: 100vh; width: 100%">
		<looker-embded
			*ngIf="dashboard && !isSupersetEnabled"
			[dashboard]="dashboard"
			messageLoading="{{
				'PAGES.FINANCIALS.REPORT_MESSAGE_LOADING' | translate
			}}"
		></looker-embded>
		<superset-embed
			*ngIf="dashboard && isSupersetEnabled"
			[dashboard]="dashboard"
			heightIframePx="800"
			messageLoading="{{
				'PAGES.FINANCIALS.REPORT_MESSAGE_LOADING' | translate
			}}"
		></superset-embed>
	</div>
</section>
